import React from "react";
import { Translate } from "react-localize-redux";

/* Карт холбосон ч автомат сунгалт идэвхгүй хэрэглэгчид идэвхжүүлэхийг
   санал болгоно. Загвар нь төлбөрийн хуудасны попаптай ижил
   (`.approval-modal`, `_payment.scss`).

   - "Идэвхжүүлэх" -> onAccept
   - "Үгүй"        -> onDecline (дахин тэр даруй асуухгүй)
   - × / гадна дарах -> onDismiss (юу ч өөрчлөхгүй)
   - done=true үед амжилтын мэдэгдэл + "Хаах" (onDismiss) */
export default function AutoRenewOfferModal({
  open,
  cardNumber,
  busy,
  error,
  done,
  onAccept,
  onDecline,
  onDismiss,
}) {
  if (!open) return null;

  return (
    <div className="approval-modal-overlay" onClick={onDismiss}>
      <div
        className="approval-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auto-renew-offer-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close-btn" onClick={onDismiss} aria-label="×">
          ×
        </button>
        <h3 className="modal-title" id="auto-renew-offer-title">
          <Translate id={done ? "profile.offer-enabled" : "profile.offer-title"} />
        </h3>
        <div className="approval-content">
          {cardNumber ? <p className="modal-main-text">{cardNumber}</p> : null}
          <p className="modal-subtitle">
            <Translate id={done ? "profile.offer-enabled-text" : "profile.offer-text"} />
          </p>
          {error ? (
            <p className="modal-subtitle auto-renew-offer-error" role="alert">
              <Translate id="profile.offer-failed" />
            </p>
          ) : null}
        </div>
        <div className="approval-buttons">
          {done ? (
            <button className="btn-approve" onClick={onDismiss}>
              <Translate id="profile.offer-close" />
            </button>
          ) : (
            <>
              <button className="btn-approve" onClick={onAccept} disabled={busy}>
                <Translate id="profile.offer-accept" />
              </button>
              <button className="btn-decline" onClick={onDecline} disabled={busy}>
                <Translate id="profile.no" />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
